import createCrudVuexModule from "@/store/crud";

export const possibleEffect = createCrudVuexModule({
  namespaced: true,
  path: "/library/possible-effect",
  moduleName: `possible-effect`,
});

export const workspacePossibleEffect = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/possible-effect",
});

export const managementPossibleEffect = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/possible-effect",
});
